import storage from "./storage";

export default async function clearLocalData() {
  // clear sw caches
  if ("serviceWorker" in navigator) {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        caches.delete(cacheName);
      });
    });
  }
  // clear indexedDB
  const dbs = await window.indexedDB.databases();
  dbs.forEach((db) => {
    if (!db.name) return;
    window.indexedDB.deleteDatabase(db.name);
  });
  // clear local storage
  await storage.clear();
}
